import React, { useState } from 'react'
import { Drawer, Button, Empty, Badge, Spin } from 'antd'
import { FilterOutlined } from '@ant-design/icons'
import { AlarmFilters } from './components/AlarmFilters'
import { FilterButton } from './components/FilterButton'
import { AlarmCard } from './components/AlarmCard'
import { AlarmMap } from './components/AlarmMap'
import { alertKey } from './components/alertKey'
import { DateFilter } from '../common/DateFilter'
import './styles/alarm_history_desktop.scss'
import './styles/alarm_filters.scss'

// Unified-responsive desktop Alerts: a top toolbar (interval + filters) over a two-pane
// body — the same AlarmCard list as mobile on the left, a hazard-colored alert map on the
// right. Replaces the old cramped Sider + table layout. State lives in index.jsx.
export const AlarmHistoryDesktop = ({
  alerts, loading, INTERVALS, selectedInterval, setInterval, onCustomDates,
  units, appVersions, isSpecial, onClick, selectedKeys, setSelectedKeys, getSetState,
  handleDetectionClick, typeDict, levelDict, selectedKey, viewedKeys,
}) => {
  const [filtersOpen, setFiltersOpen] = useState(false)

  return (
    <div className="rz-alarms-desktop">
      <div className="rz-alarmsd-toolbar">
        <DateFilter
          options={INTERVALS}
          value={selectedInterval}
          onChange={(v) => setInterval({ key: v })}
          onCustomRange={onCustomDates}
          rightSlot={
            <>
              <Badge count={selectedKeys.length} size="small" offset={[-2, 2]}>
                <Button icon={<FilterOutlined />} onClick={() => setFiltersOpen(true)}>Filters</Button>
              </Badge>
              <span className="rz-alarmsd-count">{(alerts && alerts.length) || 0} alert{((alerts && alerts.length) === 1) ? '' : 's'}</span>
            </>
          }
        />
      </div>

      {selectedKeys.length > 0 && (
        <div className="rz-alarmsd-activechips">
          <span className="rz-alarmsd-chipslbl">Active filters:</span>
          {selectedKeys.map((filter) => (
            <FilterButton
              key={String(filter)}
              value={filter[0]}
              setFilter={getSetState(filter[1])}
              selectedKeys={selectedKeys}
              setSelectedKeys={setSelectedKeys}
            />
          ))}
        </div>
      )}

      <div className="rz-alarmsd-body">
        <div className="rz-alarmsd-list">
          {loading
            ? <div className="rz-alarmsd-loading"><Spin /></div>
            : (alerts && alerts.length)
              ? alerts.map(([counter, a]) => {
                  const key = alertKey(a)
                  return (
                    <AlarmCard
                      key={`${counter}-${a.detection_date}`}
                      alert={a}
                      typeDict={typeDict}
                      levelDict={levelDict}
                      onClick={() => handleDetectionClick(a)}
                      selected={key === selectedKey}
                      viewed={viewedKeys?.has(key)}
                    />
                  )
                })
              : <Empty className="rz-alarmsd-empty" description="No alerts in this range" />}
        </div>
        <div className="rz-alarmsd-map">
          <AlarmMap alerts={alerts} typeDict={typeDict} onSelect={handleDetectionClick} selectedKey={selectedKey} />
        </div>
      </div>

      <Drawer
        className="rz-alarms-filters"
        title="Filters"
        placement="right"
        width={340}
        open={filtersOpen}
        onClose={() => setFiltersOpen(false)}
      >
        <AlarmFilters
          units={units}
          appVersions={appVersions}
          isSpecial={isSpecial}
          selectedKeys={selectedKeys}
          onClick={onClick}
        />
      </Drawer>
    </div>
  )
}

export default AlarmHistoryDesktop
